export default __webpack_public_path__ + "static/media/Guru-Parampara-22.c5e8fb49.png";